import { PaymentInstrument } from "@api/graphql/generated/generated-types";
import { StarIcon, TrashIcon } from "@heroicons/react/24/outline";
import { StarIcon as SolidStarIcon } from "@heroicons/react/24/solid";
import CourieButton from "@src/common/components/Button/Button";
import { Tooltip } from "@src/common/components";

interface PaymentMethodRowActionsProps {
  paymentMethod: PaymentInstrument;
  onUpdateDefaultPaymentMethod?: (
    paymentMethod: PaymentInstrument,
    isDefault: boolean
  ) => void;
  onDeletePaymentMethod?: (paymentMethod: PaymentInstrument) => void;
}

export function PaymentMethodRowActions({
  paymentMethod,
  onUpdateDefaultPaymentMethod,
  onDeletePaymentMethod,
}: PaymentMethodRowActionsProps) {
  if (!onUpdateDefaultPaymentMethod && !onDeletePaymentMethod) return null;

  const defaultActionLabel = paymentMethod.isDefault
    ? "Remove default"
    : "Set as default";

  return (
    <div className="ml-auto flex items-center gap-1">
      {onUpdateDefaultPaymentMethod && (
        <Tooltip content={defaultActionLabel} placement="left">
          <CourieButton
            aria-label={defaultActionLabel}
            onClick={(e) => {
              e.stopPropagation();
              onUpdateDefaultPaymentMethod(
                paymentMethod,
                !paymentMethod.isDefault
              );
            }}
            color="light"
            size="xs"
          >
            {paymentMethod.isDefault ? (
              <SolidStarIcon className="w-4 h-4 text-yellow-500" />
            ) : (
              <StarIcon className="w-4 h-4" />
            )}
          </CourieButton>
        </Tooltip>
      )}
      {onDeletePaymentMethod && (
        <Tooltip content="Delete Payment Method" placement="left">
          <CourieButton
            onClick={(e) => {
              e.stopPropagation();
              onDeletePaymentMethod(paymentMethod);
            }}
            color={"red"}
            size="xs"
          >
            <TrashIcon className="w-4 h-4" />
          </CourieButton>
        </Tooltip>
      )}
    </div>
  );
}
